/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedProjectKeyRouteImport } from './routes/_authed/$projectKey'
import { Route as AuthedCalendarRouteImport } from './routes/_authed/calendar'
import { Route as AuthedInboxRouteImport } from './routes/_authed/inbox'
import { Route as AuthedMyRouteImport } from './routes/_authed/my'
import { Route as AuthedObjectivesRouteImport } from './routes/_authed/objectives'
import { Route as AuthedRepeatingRouteImport } from './routes/_authed/repeating'
import { Route as AuthedSuggestionsRouteImport } from './routes/_authed/suggestions'
import { Route as AuthedProjectKeyBoardRouteImport } from './routes/_authed/$projectKey_.board'
import { Route as AuthedItemRefRouteImport } from './routes/_authed/item.$ref'
import { Route as AuthedSettingsLabelsRouteImport } from './routes/_authed/settings/labels'
import { Route as AuthedSettingsProfileRouteImport } from './routes/_authed/settings/profile'
import { Route as AuthedSettingsProjectsRouteImport } from './routes/_authed/settings/projects'
import { Route as AuthedSettingsSessionsRouteImport } from './routes/_authed/settings/sessions'
import { Route as AuthedSettingsUsersRouteImport } from './routes/_authed/settings/users'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProjectKeyRoute = AuthedProjectKeyRouteImport.update({
  id: '/$projectKey',
  path: '/$projectKey',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCalendarRoute = AuthedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInboxRoute = AuthedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMyRoute = AuthedMyRouteImport.update({
  id: '/my',
  path: '/my',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedObjectivesRoute = AuthedObjectivesRouteImport.update({
  id: '/objectives',
  path: '/objectives',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRepeatingRoute = AuthedRepeatingRouteImport.update({
  id: '/repeating',
  path: '/repeating',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSuggestionsRoute = AuthedSuggestionsRouteImport.update({
  id: '/suggestions',
  path: '/suggestions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProjectKeyBoardRoute = AuthedProjectKeyBoardRouteImport.update({
  id: '/$projectKey_/board',
  path: '/$projectKey/board',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedItemRefRoute = AuthedItemRefRouteImport.update({
  id: '/item/$ref',
  path: '/item/$ref',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsLabelsRoute = AuthedSettingsLabelsRouteImport.update({
  id: '/settings/labels',
  path: '/settings/labels',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsProfileRoute = AuthedSettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsProjectsRoute = AuthedSettingsProjectsRouteImport.update({
  id: '/settings/projects',
  path: '/settings/projects',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsSessionsRoute = AuthedSettingsSessionsRouteImport.update({
  id: '/settings/sessions',
  path: '/settings/sessions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsUsersRoute = AuthedSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/$projectKey': typeof AuthedProjectKeyRoute
  '/calendar': typeof AuthedCalendarRoute
  '/inbox': typeof AuthedInboxRoute
  '/my': typeof AuthedMyRoute
  '/objectives': typeof AuthedObjectivesRoute
  '/repeating': typeof AuthedRepeatingRoute
  '/suggestions': typeof AuthedSuggestionsRoute
  '/$projectKey/board': typeof AuthedProjectKeyBoardRoute
  '/item/$ref': typeof AuthedItemRefRoute
  '/settings/labels': typeof AuthedSettingsLabelsRoute
  '/settings/profile': typeof AuthedSettingsProfileRoute
  '/settings/projects': typeof AuthedSettingsProjectsRoute
  '/settings/sessions': typeof AuthedSettingsSessionsRoute
  '/settings/users': typeof AuthedSettingsUsersRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/$projectKey': typeof AuthedProjectKeyRoute
  '/calendar': typeof AuthedCalendarRoute
  '/inbox': typeof AuthedInboxRoute
  '/my': typeof AuthedMyRoute
  '/objectives': typeof AuthedObjectivesRoute
  '/repeating': typeof AuthedRepeatingRoute
  '/suggestions': typeof AuthedSuggestionsRoute
  '/': typeof AuthedIndexRoute
  '/$projectKey/board': typeof AuthedProjectKeyBoardRoute
  '/item/$ref': typeof AuthedItemRefRoute
  '/settings/labels': typeof AuthedSettingsLabelsRoute
  '/settings/profile': typeof AuthedSettingsProfileRoute
  '/settings/projects': typeof AuthedSettingsProjectsRoute
  '/settings/sessions': typeof AuthedSettingsSessionsRoute
  '/settings/users': typeof AuthedSettingsUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/_authed/$projectKey': typeof AuthedProjectKeyRoute
  '/_authed/calendar': typeof AuthedCalendarRoute
  '/_authed/inbox': typeof AuthedInboxRoute
  '/_authed/my': typeof AuthedMyRoute
  '/_authed/objectives': typeof AuthedObjectivesRoute
  '/_authed/repeating': typeof AuthedRepeatingRoute
  '/_authed/suggestions': typeof AuthedSuggestionsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/$projectKey_/board': typeof AuthedProjectKeyBoardRoute
  '/_authed/item/$ref': typeof AuthedItemRefRoute
  '/_authed/settings/labels': typeof AuthedSettingsLabelsRoute
  '/_authed/settings/profile': typeof AuthedSettingsProfileRoute
  '/_authed/settings/projects': typeof AuthedSettingsProjectsRoute
  '/_authed/settings/sessions': typeof AuthedSettingsSessionsRoute
  '/_authed/settings/users': typeof AuthedSettingsUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/setup'
    | '/$projectKey'
    | '/calendar'
    | '/inbox'
    | '/my'
    | '/objectives'
    | '/repeating'
    | '/suggestions'
    | '/$projectKey/board'
    | '/item/$ref'
    | '/settings/labels'
    | '/settings/profile'
    | '/settings/projects'
    | '/settings/sessions'
    | '/settings/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/setup'
    | '/$projectKey'
    | '/calendar'
    | '/inbox'
    | '/my'
    | '/objectives'
    | '/repeating'
    | '/suggestions'
    | '/'
    | '/$projectKey/board'
    | '/item/$ref'
    | '/settings/labels'
    | '/settings/profile'
    | '/settings/projects'
    | '/settings/sessions'
    | '/settings/users'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/setup'
    | '/_authed/$projectKey'
    | '/_authed/calendar'
    | '/_authed/inbox'
    | '/_authed/my'
    | '/_authed/objectives'
    | '/_authed/repeating'
    | '/_authed/suggestions'
    | '/_authed/'
    | '/_authed/$projectKey_/board'
    | '/_authed/item/$ref'
    | '/_authed/settings/labels'
    | '/_authed/settings/profile'
    | '/_authed/settings/projects'
    | '/_authed/settings/sessions'
    | '/_authed/settings/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SetupRoute: typeof SetupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$projectKey': {
      id: '/_authed/$projectKey'
      path: '/$projectKey'
      fullPath: '/$projectKey'
      preLoaderRoute: typeof AuthedProjectKeyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/calendar': {
      id: '/_authed/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthedCalendarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inbox': {
      id: '/_authed/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthedInboxRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/my': {
      id: '/_authed/my'
      path: '/my'
      fullPath: '/my'
      preLoaderRoute: typeof AuthedMyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/objectives': {
      id: '/_authed/objectives'
      path: '/objectives'
      fullPath: '/objectives'
      preLoaderRoute: typeof AuthedObjectivesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/repeating': {
      id: '/_authed/repeating'
      path: '/repeating'
      fullPath: '/repeating'
      preLoaderRoute: typeof AuthedRepeatingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/suggestions': {
      id: '/_authed/suggestions'
      path: '/suggestions'
      fullPath: '/suggestions'
      preLoaderRoute: typeof AuthedSuggestionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$projectKey_/board': {
      id: '/_authed/$projectKey_/board'
      path: '/$projectKey/board'
      fullPath: '/$projectKey/board'
      preLoaderRoute: typeof AuthedProjectKeyBoardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/item/$ref': {
      id: '/_authed/item/$ref'
      path: '/item/$ref'
      fullPath: '/item/$ref'
      preLoaderRoute: typeof AuthedItemRefRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/labels': {
      id: '/_authed/settings/labels'
      path: '/settings/labels'
      fullPath: '/settings/labels'
      preLoaderRoute: typeof AuthedSettingsLabelsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/profile': {
      id: '/_authed/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthedSettingsProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/projects': {
      id: '/_authed/settings/projects'
      path: '/settings/projects'
      fullPath: '/settings/projects'
      preLoaderRoute: typeof AuthedSettingsProjectsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/sessions': {
      id: '/_authed/settings/sessions'
      path: '/settings/sessions'
      fullPath: '/settings/sessions'
      preLoaderRoute: typeof AuthedSettingsSessionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/users': {
      id: '/_authed/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthedSettingsUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedProjectKeyRoute: typeof AuthedProjectKeyRoute
  AuthedCalendarRoute: typeof AuthedCalendarRoute
  AuthedInboxRoute: typeof AuthedInboxRoute
  AuthedMyRoute: typeof AuthedMyRoute
  AuthedObjectivesRoute: typeof AuthedObjectivesRoute
  AuthedRepeatingRoute: typeof AuthedRepeatingRoute
  AuthedSuggestionsRoute: typeof AuthedSuggestionsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedProjectKeyBoardRoute: typeof AuthedProjectKeyBoardRoute
  AuthedItemRefRoute: typeof AuthedItemRefRoute
  AuthedSettingsLabelsRoute: typeof AuthedSettingsLabelsRoute
  AuthedSettingsProfileRoute: typeof AuthedSettingsProfileRoute
  AuthedSettingsProjectsRoute: typeof AuthedSettingsProjectsRoute
  AuthedSettingsSessionsRoute: typeof AuthedSettingsSessionsRoute
  AuthedSettingsUsersRoute: typeof AuthedSettingsUsersRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedProjectKeyRoute: AuthedProjectKeyRoute,
  AuthedCalendarRoute: AuthedCalendarRoute,
  AuthedInboxRoute: AuthedInboxRoute,
  AuthedMyRoute: AuthedMyRoute,
  AuthedObjectivesRoute: AuthedObjectivesRoute,
  AuthedRepeatingRoute: AuthedRepeatingRoute,
  AuthedSuggestionsRoute: AuthedSuggestionsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedProjectKeyBoardRoute: AuthedProjectKeyBoardRoute,
  AuthedItemRefRoute: AuthedItemRefRoute,
  AuthedSettingsLabelsRoute: AuthedSettingsLabelsRoute,
  AuthedSettingsProfileRoute: AuthedSettingsProfileRoute,
  AuthedSettingsProjectsRoute: AuthedSettingsProjectsRoute,
  AuthedSettingsSessionsRoute: AuthedSettingsSessionsRoute,
  AuthedSettingsUsersRoute: AuthedSettingsUsersRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  SetupRoute: SetupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
